/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import {
	isSchemaConstArrayModel,
	isSchemaConstObjectModel,
	isSchemaConstStringModel,
	TGenericModelNode
} from "@adapptio/lib-blueprint";
import {
	isSelectionItemPage,
	TReadmeEditSelectionItem
} from "../../../Common/ReadmeEditSelection";
import { InspectArrayItem } from "../../../../../ui/components/Inspector/InspectArrayItem";

export interface IReadmeEditorInspectorItemProps {
	selectionItem: TReadmeEditSelectionItem;
	getNodeById: (nodeId: number) => TGenericModelNode;
}

const pathPage = [ "$page" ];

export const ReadmeEditorInspectorItem: React.FC<IReadmeEditorInspectorItemProps> = ({
	selectionItem,
	getNodeById
}) => {
	if (isSelectionItemPage(selectionItem)) {
		const modelNode = getNodeById(selectionItem.nodeId);
		const parentListModel = getNodeById(selectionItem.parentListModelId);

		if (!isSchemaConstObjectModel(modelNode) || !isSchemaConstArrayModel(parentListModel)) {
			return null;
		}

		const nameModel = isSchemaConstStringModel(modelNode.props.title) ? modelNode.props.title : undefined;

		return (
			<InspectArrayItem
				model={modelNode}
				parentListModel={parentListModel}
				nameModel={nameModel}
				depth={0}
				path={pathPage}
				title="Page"
			/>
		);
	}

	return null;
};
